import React from "react";
import { StoryblokInfoCard } from "../../../interfaces/Storyblok/StoryblokInfoCard.interface";
import Image from "../../atoms/Image/Image.atom";
import RichText from "../../atoms/RichText/RichText.atom";
import Button from "../../atoms/Button/Button.component";
import { ButtonProps } from "../../../interfaces/Button.interface";
import { ButtonSizeTypes } from "../../../interfaces/enums/ButtonSizeTypes.enum";
import { ButtonTypes } from "../../../interfaces/enums/ButtonTypes.enum";

const InfoCard: React.FC<StoryblokInfoCard> = ({ image, title, description, cta }) => {
  const isCtaPopulated = (ctaBlocks: ButtonProps[]): boolean =>
    Array.isArray(ctaBlocks) && ctaBlocks.length > 0 && !!ctaBlocks[0].label && !!ctaBlocks[0].link;

  return (
    <div className="flex h-full flex-col">
      {image?.filename && (
        <div className="overflow-hidden rounded-[24px] shadow-2xl">
          <div className="aspect-[16/10] w-full">
            <Image image={image} objectFit="cover" fluidMaxWidth={1200} />
          </div>
        </div>
      )}

      {title && <h3 className="mt-6 text-2xl font-extrabold leading-tight text-Primary-900">{title}</h3>}

      {description && (
        <div className="mt-4 flex-1 text-Body">
          <RichText
            hasHeadingAbove={Boolean(title)}
            headingAboveLevel={3}
            content={description}
            className="[&_p+p]:!mt-6"
          />
        </div>
      )}

      {isCtaPopulated(cta) && (
        <Button
          link={cta[0].link}
          label={cta[0].label}
          type={ButtonTypes.PRIMARY}
          size={ButtonSizeTypes.LG}
          className="mt-6 self-start !text-base"
        />
      )}
    </div>
  );
};

export default InfoCard;
